import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import { EXPERIENCE_SHOP_COOP_MANAGE } from '@constant'
import { Flex } from 'hljd'
import Info from './Info'
import RelateOrder from './RelateOrder'
import BillList from './BillList'
import Store from './store'
import { Provider } from 'mobx-react'

export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.cooperateOrderDetail(this.props.params.id)
  }

  render() {
    const header = [
      <Link to={EXPERIENCE_SHOP_COOP_MANAGE}>合作账户管理</Link>,
      '合作订单详情'
    ]

    return (
      <Provider detailStore={this.store}>
        <HeaderView header={header} title="合作订单详情">
          <Flex style={{ marginTop: 20, marginBottom: 10 }}>
            <Info />
            <RelateOrder />
          </Flex>

          <BillList />
        </HeaderView>
      </Provider>
    )
  }
}
